export const prodConfig = {
  apiHostUrl: "https://apiprod.cuvo.io",
  apiChatUrl: "https://chatprod.cuvo.io",
  feedbackMailAccount: "help@cuvo.io",
  enableZendesk: true,
  enableJira: true,
  enableMailReply: true,
  enableInsights: true,
  logLevel: "error",
  enableAnalytics: false,
  enableAiSettingsModelArchitecture: false,
  enableChatbot: true,
  enableFeedback: true,
  enableBugReport: true,
  enableFeatureRequest: true,
  enablePlaystore: true,
  enableCorrelation: true,
  enableDynamicFeedback: false,
  enableRecaptcha: false,
  uploadFileBucketName: "dashboard-cuvo-upload-photos",
  roleConfig: {
    "Admin": "role_54a4abb0-5baa-11ee-95c8-61f5b13b77a6",
    "Manager": "role_1e5aa4a0-ee73-11ed-8433-9b65a494e10c",
    "Member": "role_5c223f90-f49b-11ed-9950-752210f6963e",
    "SuperAdmin": "role_da964420-ef4b-11ed-b335-9b40a9a62793",
  },
  reCaptchaSiteKey: "6Le3SWgpAAAAAB_QVLCOB_jFdckwI5gIub7gQhlw",
  commonEncrypt: {
    secret_key: "prod_cuvo_platform",
    iv: "c8cd7096782e773bbb556c791886d1fb5fa2d62e", // sha1 hash generator value for prodcuvoplatform
  },
  ec2HostURL: "https://apiprod2.cuvo.io",
};
